import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarContainer } from '../components/calendar/CalendarContainer';
import CalendarView from '../components/CalendarView';
import { useIsMobile } from '../hooks/useMediaQuery';

const CalendarPage: React.FC = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <CalendarContainer>
      <div className="h-screen h-screen-mobile overflow-hidden flex flex-col">
        <div className="flex-1 min-h-0 overflow-hidden">
          <CalendarView isMobile={isMobile} onBack={() => navigate('/')} />
        </div>
      </div>
    </CalendarContainer>
  );
};

export default CalendarPage;
